import { render, staticRenderFns } from "./RegisterSuccess.vue?vue&type=template&id=50dcfe68&scoped=true"
import script from "./RegisterSuccess.vue?vue&type=script&lang=ts"
export * from "./RegisterSuccess.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSuccess.vue?vue&type=style&index=0&id=50dcfe68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50dcfe68",
  null
  
)

export default component.exports